import { Type } from "class-transformer";

export class UpdatePupilDto {

    pupilId: number = 0;
    level: string = null;
    notePupilsList: string = null;
    addToCourses: number[] = [];
    removeFromCourses: number[] = [];

    constructor(pupilId: number) {
        this.pupilId = pupilId;
    }
}
